var _path, _path2, _path3, _path4, _path5, _ellipse, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedicialCommitte(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 71,
    viewBox: "0 0 75 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M40.4772 10.8364C35.6581 11.9057 31.6191 14.348 29.1571 18.0952C27.1317 21.1783 25.9475 24.752 23.0547 27.3653C19.9729 30.149 17.4723 31.6065 13.1146 32.0381C-2.77585 33.6126 -2.14232 56.1987 12.7234 65.1886C27.589 74.1784 59.668 72.9883 68.9267 46.9508C78.1853 20.9134 64.6247 13.8335 53.4748 11.0243C49.4171 10.0017 44.7446 9.88947 40.4772 10.8364Z",
    fill: "#E7EDFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3423 36.5469C10.3423 26.7689 10.3423 21.8799 13.3721 18.8423C16.402 15.8047 21.2784 15.8047 31.0313 15.8047H41.3758C51.1287 15.8047 56.0052 15.8047 59.035 18.8423C62.0649 21.8799 62.0649 26.7689 62.0649 36.5469C62.0649 46.3249 62.0649 51.2139 59.035 54.2515C56.0052 57.2892 51.1287 57.2892 41.3758 57.2892H31.0313C21.2784 57.2892 16.402 57.2892 13.3721 54.2515C10.3423 51.2139 10.3423 46.3249 10.3423 36.5469Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1756 16.9056C16.5865 16.6113 17.0792 16.4531 17.5845 16.4531H53.6778C54.09 16.4531 54.4953 16.5584 54.8553 16.7589L59.0531 19.097C59.7269 19.4723 60.1815 20.1464 60.2769 20.9117L60.7717 24.8797H10.6704L12.0405 20.4703C12.197 19.9666 12.5137 19.5279 12.9425 19.2209L16.1756 16.9056Z",
    fill: "#B7CCFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3423 36.5469C10.3423 26.7689 10.3423 21.8799 13.3721 18.8423C16.402 15.8047 21.2784 15.8047 31.0313 15.8047H41.3758C51.1287 15.8047 56.0052 15.8047 59.035 18.8423C62.0649 21.8799 62.0649 26.7689 62.0649 36.5469C62.0649 46.3249 62.0649 51.2139 59.035 54.2515C56.0052 57.2892 51.1287 57.2892 41.3758 57.2892H31.0313C21.2784 57.2892 16.402 57.2892 13.3721 54.2515C10.3423 51.2139 10.3423 46.3249 10.3423 36.5469Z",
    stroke: "#081E54",
    strokeWidth: 1.94459
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5479 15.8086C46.5479 10.9196 46.5479 8.47513 45.033 6.95632C43.5181 5.4375 41.0799 5.4375 36.2034 5.4375C31.327 5.4375 28.8887 5.4375 27.3738 6.95632C25.8589 8.47513 25.8589 10.9196 25.8589 15.8086",
    stroke: "#081E54",
    strokeWidth: 1.94459
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.2034,
    cy: 36.5508,
    rx: 10.3445,
    ry: 10.3711,
    fill: "#A020FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0826 36.5454H32.3242M36.2034 32.6562V40.4346",
    stroke: "white",
    strokeWidth: 1.94459,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.21811 34.4262C3.21811 35.2328 2.56608 35.8854 1.76344 35.8854C0.960803 35.8854 0.308773 35.2328 0.308773 34.4262C0.308773 33.6195 0.960803 32.967 1.76344 32.967C2.56608 32.967 3.21811 33.6195 3.21811 34.4262Z",
    stroke: "#081E54",
    strokeWidth: 0.621453
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6907 20.3425C74.6907 21.9616 73.3818 23.2728 71.7688 23.2728C70.1558 23.2728 68.8469 21.9616 68.8469 20.3425C68.8469 18.7235 70.1558 17.4123 71.7688 17.4123C73.3818 17.4123 74.6907 18.7235 74.6907 20.3425Z",
    stroke: "#081E54",
    strokeWidth: 0.621453
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M68.5355 34.3617C68.5355 34.0497 68.7862 33.7969 69.0957 33.7969L73.9144 33.7969C74.2238 33.7969 74.4746 34.0497 74.4746 34.3617C74.4746 34.6737 74.2238 34.9265 73.9144 34.9265L69.0957 34.9265C68.7862 34.9265 68.5355 34.6737 68.5355 34.3617Z",
    fill: "#3A6EEC"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9464 36.7821L70.9464 31.9242C70.9464 31.6122 71.1971 31.3594 71.5066 31.3594C71.8161 31.3594 72.0669 31.6122 72.0669 31.9242L72.0669 36.7821C72.0669 37.0941 71.8161 37.3469 71.5066 37.3469C71.1971 37.3469 70.9464 37.0941 70.9464 36.7821Z",
    fill: "#3A6EEC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicialCommitte);
export default __webpack_public_path__ + "static/media/MedicialCommitte.048599ec59341332546cd9c7110687a1.svg";
export { ForwardRef as ReactComponent };